import { supabase } from './supabase';

export async function verifyTurnstileToken(token: string): Promise<boolean> {
  try {
    const { data, error } = await supabase.functions.invoke('vietnamtravel-verify-turnstile', {
      body: { token },
    });
    if (error) return false;
    return data?.ok === true;
  } catch {
    return false;
  }
}